import React from 'react'
// import clsx from 'clsx'
import { useBreakpoint } from 'utils/Hooks'
import { ListVirtualizedConfigsProps, SimpleList } from 'components/ListVirtualized'
// import stylesGlobal from 'stylesGlobal.module.scss'

type ValueResponsiveProp = {
  xs?: number
  sm?: number
  md?: number
  lg?: number
  xl?: number
}

type ListLoadingProps = {
  config?: ListVirtualizedConfigsProps
  component?: React.ReactNode
  items?: number | ValueResponsiveProp
}

export const setResponsiveValue = (breakpointData: any, value: ValueResponsiveProp) => {
  if (!value) return undefined

  const { breakpoint, isSmallscreenAbove, isMediumscreenAbove, isLargescreenAbove } = breakpointData

  let adjustedValue = 0

  if (breakpoint === 'xs' && value['xs']) adjustedValue = { ...value }['xs'] || adjustedValue
  if (isSmallscreenAbove && value['sm']) adjustedValue = { ...value }['sm'] || adjustedValue
  if (isMediumscreenAbove && value['md']) adjustedValue = { ...value }['md'] || adjustedValue
  if (isLargescreenAbove && value['lg']) adjustedValue = { ...value }['lg'] || adjustedValue
  if (breakpoint === 'xl' && value['xl']) adjustedValue = { ...value }['xl'] || adjustedValue

  return adjustedValue
}

const ListLoading: React.FC<ListLoadingProps> = props => {
  const { component, config, items = 1 } = props

  const breakpointData = useBreakpoint()

  const adjustedItems =
    typeof items === 'number' ? items : setResponsiveValue(breakpointData, items)

  return (
    <SimpleList
      config={config}
      data={[...Array(adjustedItems)]}
      renderItem={() => {
        return component
      }}
    />
  )
}

export default ListLoading
